export const TASTING_VIDEO = 'https://vimeo.com/1024681666';
export const TASTING_VIDEO_PLAYER = 'https://player.vimeo.com/video/1024681666?autoplay=1&title=0&byline=0';
export const TASTING_VIDEO_IMAGE =
    'https://simplewine.ru/static/local/assets/images/degustations/degustations_video.png';

export const RAW_TASTING_IMAGES = [
    'https://simplewine.ru/static/local/assets/images/degustations/degustations1.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations2.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations3.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations4.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations5.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations6.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations7.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations8.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations9.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations10.jpg',
    'https://simplewine.ru/static/local/assets/images/degustations/degustations11.jpg',
];

export const TASTING_IMAGES = [TASTING_VIDEO_IMAGE, ...RAW_TASTING_IMAGES];
